<template>
  <div class="ai-bar-collapsed" @click="$emit('expand')">
    <div class="ai-pulse"></div>
    <span class="ai-placeholder">{{ placeholder }}</span>
    <span class="ai-arrow">&#8593;</span>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  activePanel: {
    type: String,
    default: ''
  },
  // Where the bar goes: the Mystic whose room it opens (navigation-design §7).
  mysticName: { type: String, default: '' },
})

defineEmits(['expand'])

const placeholder = computed(() => {
  // It opens that Mystic's room, so it says so (it said "MysticAIda" or "The
  // Keeper" while opening someone else).
  if (props.mysticName) return `Ask ${props.mysticName} anything...`
  const map = {
    altar: 'The Keeper is present...',
    community: 'Ask MysticAIda about the community...',
    quest: 'Ask MysticAIda about your quest...',
  }
  return map[props.activePanel] || 'Ask MysticAIda anything...'
})
</script>

<style scoped>
.ai-bar-collapsed {
  height: 40px;
  background: #0f0520;
  border-top: 1px solid #663399;
  display: flex;
  align-items: center;
  padding: 0 14px;
  gap: 10px;
  cursor: pointer;
  flex-shrink: 0;
  width: 100%;
  box-sizing: border-box;
}
.ai-pulse {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #663399;
  flex-shrink: 0;
}
.ai-placeholder {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.3);
  flex: 1;
}
.ai-arrow {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.2);
}
</style>
